

function get_branch_name(id) {
    let name;
    switch (id) {
        case 7:
            name = 'Kokshetau';
            break;
        case 12:
            name = 'Nur-Sultan';
            break;
        case 11:
            name = 'Nur-Sultan';
            break;
        case 14:
            name = 'Pavlodar';
            break;
        case 3:
            name = 'Kyzylorda';
            break;
        case 10:
            name = 'Aktobe';
            break;
        case 4:
            name = 'Aktau';
            break;
        case 9:
            name = 'Zhambyl';
            break;
        case 5:
            name = 'Atyrau';
            break;
        case 13:
            name = 'Shymkent';
            break;
        case 15:
            name = 'Karagandy';
            break;
        case 6:
            name = 'Almaty';
            break;
        case 8:
            name = 'Kostanay';
            break;
        case 16:
            name = 'Semey';
            break;
        case 17:
            name = 'Oskemen';
            break;
        default:
            name = 'Nur-Sultan';

    }
    return name
}

export default get_branch_name
